import { useRef } from "react";

/**
 * `useShallow` with a caller-supplied equality. The returned zustand selector
 * hands back its previous result while `isEqual` holds, so a store update
 * that leaves the derived value unchanged (an unrelated node move, a pan)
 * does not re-render the subscriber.
 */
export function useEqualSelector<S, T>(
  selector: (state: S) => T,
  isEqual: (previous: T, next: T) => boolean,
): (state: S) => T {
  const previous = useRef<{ value: T } | null>(null);
  return (state) => {
    const next = selector(state);
    if (previous.current && isEqual(previous.current.value, next)) {
      return previous.current.value;
    }
    previous.current = { value: next };
    return next;
  };
}
